import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/lems-v1/images/projects/all-project-icon.svg'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "project-status-chart" }
const _hoisted_4 = { class: "status-issue-type" }
const _hoisted_5 = { class: "status-issue-select" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "chart_box" }
const _hoisted_8 = {
  key: 0,
  class: "no-data"
}
const _hoisted_9 = {
  key: 1,
  class: "chart-container"
}
const _hoisted_10 = { class: "donut-chart" }
const _hoisted_11 = {
  class: "donut-chart-svg",
  viewBox: "0 0 240 240"
}
const _hoisted_12 = { class: "donut-segments" }
const _hoisted_13 = ["d", "stroke", "title", "onMouseenter"]
const _hoisted_14 = {
  x: "120",
  y: "110",
  "text-anchor": "middle",
  class: "donut-center-text"
}
const _hoisted_15 = { class: "tooltip-name" }
const _hoisted_16 = { class: "tooltip-count" }
const _hoisted_17 = { class: "tooltip-percentage" }
const _hoisted_18 = { class: "custom-row" }
const _hoisted_19 = { class: "status-type" }
const _hoisted_20 = { class: "status-numbr" }
const _hoisted_21 = { class: "status-done" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isProjectDetailsMode)
      ? (_openBlock(), _createElementBlock("div", {
          class: "vertical-slider-box vertical-slider-1",
          key: `projects-${_ctx.forceRenderKey}`
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["vertical-slider-row", { active: _ctx.selectedProject === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectProject('all')))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1),
            _createElementVNode("span", null, "All Projects", -1)
          ]))], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${project.key}-${index}`,
              class: _normalizeClass(["vertical-slider-row", { active: _ctx.selectedProject === project.key }]),
              onClick: ($event: any) => (_ctx.selectProject(project.key))
            }, [
              _createElementVNode("i", null, [
                _createElementVNode("img", {
                  src: project.avatarUrls['48x48'],
                  alt: ""
                }, null, 8, _hoisted_2)
              ]),
              _createElementVNode("span", null, _toDisplayString(project.name), 1)
            ], 10, _hoisted_1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "v1-selectbox",
            id: "statusIssueTypeSelectBox",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIssueType) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterByIssueType && _ctx.filterByIssueType(...args)))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("option", { value: "all" }, "All Issue Types", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableIssueTypes, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type,
                value: type
              }, _toDisplayString(type), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedIssueType]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.validChartData.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("p", null, "No data available for the selected project", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                  _createElementVNode("g", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validChartData, (item, index) => {
                      return (_openBlock(), _createElementBlock("path", {
                        key: item.name,
                        d: _ctx.getDonutPath(index, _ctx.validChartData),
                        fill: "none",
                        stroke: _ctx.getColorForIssueType(item.name),
                        "stroke-width": "25",
                        class: "donut-segment",
                        title: `${item.name}: ${item.count} (${item.percentage}%)`,
                        onMouseenter: ($event: any) => (_ctx.showTooltip($event, item, index)),
                        onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
                      }, null, 40, _hoisted_13))
                    }), 128))
                  ]),
                  _createElementVNode("text", _hoisted_14, _toDisplayString(_ctx.getTotalIssues()), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("text", {
                    x: "120",
                    y: "130",
                    "text-anchor": "middle",
                    class: "donut-center-subtext"
                  }, " Total Issues ", -1))
                ]))
              ]),
              (_ctx.tooltipVisible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "chart-tooltip",
                    style: _normalizeStyle(_ctx.tooltipStyle)
                  }, [
                    _createElementVNode("div", {
                      class: "tooltip-content",
                      style: _normalizeStyle({ backgroundColor: _ctx.getColorForIssueType(_ctx.tooltipData?.name || '') })
                    }, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.tooltipData?.name), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.tooltipData?.count) + " tickets", 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.tooltipData?.percentage) + "%", 1)
                    ], 4),
                    _createElementVNode("div", {
                      class: "tooltip-connector",
                      style: _normalizeStyle({ backgroundColor: _ctx.getColorForIssueType(_ctx.tooltipData?.name || '') })
                    }, null, 4)
                  ], 4))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    (_openBlock(), _createElementBlock("div", {
      class: "vertical-slider-box vertical-slider-2",
      key: `issues-${_ctx.forceRenderKey}`
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredIssueTypeStats, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${item.name}-${index}`,
          class: "status-chart-details"
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("i", {
              class: "status-colors",
              style: _normalizeStyle({ backgroundColor: _ctx.getColorForIssueType(item.name) })
            }, null, 4),
            _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(item.count), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(item.percentage) + "%", 1)
          ])
        ]))
      }), 128))
    ]))
  ], 64))
}